import { z } from 'zod'
import { DepartmentPermissionsIds } from '../departments/permissions'

export type User = {
  id: string
  organization: string
  role: string
  active: boolean
  trialPeriod: boolean
  email: string
  createdAt: string
  updatedAt: string
  hasUnlimitedTokens: boolean
  otpExpiry: string | null
  favoriteTools: string[]

  department: string
  jobTitle: string
  name: string
  surname: string
  avatarUrl?: string
  avatar?: string

  publicFlags?: UserPublicFlag[]
  loginAttempts: number
  chatTokensLeft: number

  organizationName: string
  needsKDForm?: boolean

  // NOTE: Injected from separate request
  permissions?: (DepartmentPermissionsIds | string)[]

  alphaFeatureAccess: boolean
  betaFeatureAccess: boolean

  lastTosAcceptedAt: string | null

  _impersonatedBy?: string
}

export type SignupData = {
  email: string
  password: string
  company?: string
}

export const OTPStatusSchema = z.enum(['required', 'sent', 'allowed'])

export type OTPStatus = z.infer<typeof OTPStatusSchema>

export type UserPublicFlag =
  | 'used-tool'
  | 'generated-image'
  | 'analyzed-document'
  | 'invited-teammate'
  | 'added-org-info'
  | 'invite-teammate-dismissed'
